interface AllPromotionStatusI {
  name: string;
  displayName: string;
}

const AllPromotionStatus: AllPromotionStatusI = {
  name: "all-promotion-status",
  displayName: "Svi oglasi"
};

export default AllPromotionStatus;



// WEBPACK FOOTER //
// ./src/models/allPromotionStatus.ts